<ng-container [ngSwitch]="phase">
  <sbnb-connect-agoda-start
    *ngSwitchCase="'start'"
    (stepComplete)="initRequirementsScreen($event)"
  ></sbnb-connect-agoda-start>

  <sbnb-connect-agoda-requirements
    *ngSwitchCase="'requirements'"
    (stepComplete)="initInstructionsScreen()"
  ></sbnb-connect-agoda-requirements>

  <sbnb-connect-agoda-requirements-fail
    *ngSwitchCase="'requirements-fail'"
    (stepComplete)="handlePhase($event)"
  ></sbnb-connect-agoda-requirements-fail>

  <sbnb-connect-agoda-instructions
    *ngSwitchCase="'instructions'"
    (stepComplete)="initPropertyIdsScreen($event)"
  ></sbnb-connect-agoda-instructions>

  <sbnb-connect-agoda-property-ids
    *ngSwitchCase="'property-ids'"
    (propertiesEmitter)="initReviewPropertiesScreen($event)"
  ></sbnb-connect-agoda-property-ids>

  <sbnb-connect-agoda-review-properties
    *ngSwitchCase="'review-properties'"
    [propertyIds]="propertyIds"
    (propertiesEmitter)="initMarkupScreen($event)"
    (noPropertyIdsEmitter)="initPropertyIdsScreen()"
  ></sbnb-connect-agoda-review-properties>

  <sbnb-connect-set-markup
    *ngSwitchCase="'set-markup'"
    platform="agoda"
    (stepComplete)="setAccountCompleted($event)"
  ></sbnb-connect-set-markup>

  <sbnb-connect-agoda-messaging
    *ngSwitchCase="'messaging'"
    (stepComplete)="setAccountCompleted($event)"
  ></sbnb-connect-agoda-messaging>

  <sbnb-connect-done
    platform="agoda"
    *ngSwitchCase="'done'"
  ></sbnb-connect-done>
</ng-container>
